let pageConfig = {};

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '设备升级'
    },
    {
        type: 'title',
        name: '版本管理'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'messageId',
    editRouter: 'versionDetail',
};

// 路由
pageConfig.listRouter = 'versionManagement';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '设备升级',
    },
    {
        type: 'router',
        name: '版本管理',
        router: 'versionManagement'
    },
    {
        type: 'title',
        name: '版本详情',
    },
];

pageConfig.formRules = {
    manufactorId: [{
        required: true,
        message: '请选择厂商标识',
        trigger: 'change'
    }],
    versionNo:[
        {
            required: true,
            message: '请输入最新版本号',
            trigger: 'change'
        }
    ],
    versionDownloadPath: [
        {
            required: true,
            message: '请输入最新下载路径',
            trigger: 'blur'
        }
    ],
    ftpServerPath:[
        {
            required: true,
            message: '请输入FTP服务器地址',
            trigger: 'change'
        }
    ],
    ftpServerUser:[
        {
            required: true,
            message: '请输入FTP服务器用户名',
            trigger: 'change'
        }
    ],
    versionDesc:[
        {
            required: true,
            message: '请输入最新版本描述',
            trigger: 'change'
        }
    ],
    ftpServerPort:[
        {
            required: true,
            message: '请输入FTP服务器端口号',
            trigger: 'change'
        }
    ],
    ftpServerPassword:[
        {
            required: true,
            message: '请输入FTP服务器密码',
            trigger: 'change'
        }
    ]
};



export default pageConfig;